import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom"; // URL parametrelerini almak için ve Link bileşeni
import { createClient } from "@supabase/supabase-js";
import { motion } from "framer-motion"; // motion bileşenini import ediyoruz
import "../../dist.css/NewsPage.css";

// Supabase bağlantısını oluşturuyoruz
const supabase = createClient(
  "https://qlgwpthiwclfbgzzjmjw.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZ3dwdGhpd2NsZmJnenpqbWp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ2MDUzOTIsImV4cCI6MjA0MDE4MTM5Mn0.N9-IULDnpuUWR_PNXvXyzdTTIMRsxRAxVGrAagaJn4k"
);

const NewsPage = () => {
  const { idNews } = useParams(); // URL'den haber ID'sini almak için
  const [newsData, setNewsData] = useState(null); // Haber verilerini tutacak state
  const [relatedNews, setRelatedNews] = useState([]); // İlgili haberleri tutacak state
  const [loading, setLoading] = useState(true); // Yükleme durumunu tutan state
  const [error, setError] = useState(null); // Hata durumunu tutan state

  useEffect(() => {
    // Veri çekme fonksiyonu
    const fetchNews = async () => {
      setLoading(true); // Veri çekmeye başladık

      // Detaylı haber verisini çekiyoruz
      const { data, error } = await supabase
        .from("news") // "news" tablosundan veri çekiyoruz
        .select("*")
        .eq("news_id", idNews) // Parametreyle gelen ID'yi filtreliyoruz
        .single(); // Tek bir haber alıyoruz

      if (error) {
        console.error("Hata oluştu:", error);
        setError(error.message);
        setLoading(false);
        return;
      }

      if (!data) {
        setError("Veri bulunamadı.");
        setLoading(false);
        return;
      }

      setNewsData(data); // Haber verisini state'e kaydediyoruz

      // Diğer haberleri çekme işlemi
      const { data: related, error: relatedError } = await supabase
        .from("news")
        .select("*")
        .neq("news_id", idNews) // O anki haberin dışında diğerlerini çekiyoruz
        .limit(5); // En fazla 5 haber alıyoruz

      if (relatedError) {
        console.error("Hata oluştu:", relatedError);
        setError(relatedError.message);
        setLoading(false);
        return;
      }

      setRelatedNews(related); // İlgili haberleri state'e kaydediyoruz
      setLoading(false); // Yükleme işlemi tamamlandı
    };

    fetchNews(); // fetchNews fonksiyonunu çağırıyoruz
  }, [idNews]); // idNews parametresi değiştiğinde yeniden veri çek

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!newsData) {
    return <div>Haber bulunamadı.</div>;
  }

  return (
    <div className="news__details__page">
      {/* Detaylı haber için motion.div ekleniyor */}
      <motion.div
        className="news__details"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0, y: 30 }, // Başlangıçta şeffaf ve yukarıda
          visible: { opacity: 1, y: 0 }, // Görünür olmalı ve normale dönmeli
        }}
        transition={{ duration: 0.5 }} // Animasyon süresi
      >
        <h1>{newsData.news_title}</h1>
        <div className="news-content">
          <img
            src={newsData.news_img}
            alt={newsData.news_title}
            className="news-image"
          />
          {/* HTML içeriğini render etmek için dangerouslySetInnerHTML kullanıyoruz */}
          <p dangerouslySetInnerHTML={{ __html: newsData.news_content }}></p>
        </div>
      </motion.div>

      {/* Diğer Haberlerimiz başlığı ve altındaki haberler */}
      <h2 className="other-news-heading">Diğer Haberlerimiz</h2>
      <motion.div
        className="other-news-list"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0, y: 30 }, // Başlangıçta yukarıda ve şeffaf
          visible: { opacity: 1, y: 0 }, // Görünür olmalı ve normale dönmeli
        }}
        transition={{ duration: 0.5, staggerChildren: 0.2 }} // Animasyon süresi ve kartlar arasında gecikme
      >
        {relatedNews.map((news) => (
          <Link to={`/news/${news.news_id}`} key={news.news_id}>
            <motion.div
              className="other-news-item"
              variants={{
                hidden: { opacity: 0, y: 30 }, // Başlangıçta yukarıda ve şeffaf
                visible: { opacity: 1, y: 0 }, // Görünür olmalı ve normale dönmeli
              }}
              transition={{ duration: 0.5 }}
            >
              <img
                src={news.news_img}
                alt={news.news_title}
                className="other-news-image"
              />
              <h3>{news.news_title}</h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: news.news_content.slice(0, 100),
                }}
              />
            </motion.div>
          </Link>
        ))}
      </motion.div>
    </div>
  );
};

export default NewsPage;
